import calculateIcon from "assets/images/calculatePink.svg";
import accountIcon from "assets/images/account.svg";
import favicon from "assets/images/favicons/fv_account.svg";
import { ModuleNavigation } from "../../moduleTypes/moduleTypes";

export const account: ModuleNavigation = {
  favicon,
  labelBackground: "#b65eff",
  label: "Konto",
  iconBackground: "#431d87",
  icon: calculateIcon,
  menuIcon: accountIcon,
  name: "ACCOUNT",
  url: "/account",
  navigationSections: [{ navigationList: [] }],
};
